<template>
<div class="page">
    <Header title="传承师信息" />
    <div class="tips" v-if="status == 0 || status == 1 || status == -1" :class="{yellow: status == 0, blue: status == 1, red: status == -1}">
        <span>{{status_text[status]}}</span>
    </div>
    <template v-if="status == 2">
        <div class="board td-f">
            <div class="avatar">
                <img :src="dataSources.inheritor_cover" />
            </div>
            <div class="info td-f1 td-fc td-fas">
                <div class="name">
                    <span>{{dataSources.inheritor_name}}</span>
                    <span>{{dataSources.inheritor_level}}</span>
                </div>
                <div class="mobile">{{dataSources.inheritor_mobile}}</div>
            </div>
        </div>
        <div class="content">{{dataSources.inheritor_introduce}}</div>
    </template>
    <div class="footer">
        <div class="btn" @click="onPressNav('myInheritorApply')" v-if="status == 0">申请传承师</div>
        <div class="btn" @click="onPressNav('myInheritorApply')" v-if="status == -1">重新提交申请</div>
        <div class="btn" @click="onPressBack(-1)" v-if="status == 1">返回上一页</div>
        <div class="btn" @click="onPressNav('myInheritorApply', {isEdit: 1, infoData: dataSources})" v-if="status == 2">修改信息</div>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from '@/components/Header'
export default {
    components: {
        'Header': Header,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            status_text: {
                '-1': "您的传承师申请审核未通过，请重新提交申请或联系平台客服人员了解具体详情。",
                '0': "您还未申请传承师，如需成为传承师，请点击申请并填写相关信息提交审核，审核通过后即可成为传承师。",
                '1': "您的传承师申请还在审核中，请耐心等待~",
                '2': "恭喜您成为传承师！",
            },
            status: 3,
            dataSources: {
                inheritor_cover: '',
                inheritor_name: '',
                inheritor_mobile: '',
                inheritor_introduce: '',
                inheritor_level: '',
            }
        };
    },
    created() {
        this.requestData()
    },
    methods: {
        // 顶部Nav的跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },
        // 返回
        onPressBack(val) {
            this.$router.go(val)
        },
        // 请求数据
        async requestData() {
            let url = this.API.master_status;
            let params = {
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.status = result.data
                if (result.data == 2) {
                    this._requestInheritorInfo();
                }
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        async _requestInheritorInfo() {
            let url = this.API.master_agent_info;
            let params = {
                user_type: 'master',
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    padding: 10px;
    box-sizing: border-box;
}

.tips {
    padding: 20px;
    background-color: #fff;
    border-radius: 6px;

    &.blue {
        color: #004085;
        background-color: #cce5ff;
        border-color: #b8daff;
    }

    &.red {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    &.green {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
    }

    &.yellow {
        color: #856404;
        background-color: #fff3cd;
        border-color: #ffeeba;
    }
}

.board {
    margin-bottom: 10px;
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;

    .avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
    }

    .info {
        margin-left: 20px;

        .name {
            font-size: 16px;
            color: #333;
            font-weight: 600;

            .level {
                color: #6472e8;
                padding-left: 10px;
            }
        }

        .mobile {
            font-size: 14px;
            color: #888;
        }
    }
}

.content {
    border-radius: 6px;
    background-color: #fff;
    padding: 20px;
    font-size: 15px;
    color: #333;
    line-height: 2;
    text-align: justify;
    word-break: break-all;
}

.btn {
    margin: 50px 15px;
    height: 40px;
    background: linear-gradient(225deg, #9cb2f4, #6472e8);
    border-radius: 3px;
    font-size: 15px;
    color: #fff;
    text-align: center;
    line-height: 40px;
}
</style>
